import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {initialState} from '@/store/states/storage'
import {TYPE_LOGIN_ENUM} from '@/types/enums'
import httpClient from '@/services/httpClient'
import fileHttpClient from '@/services/fileHttpClient'

export const slice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    SET_ACCOUNT: (state, {payload}: PayloadAction<string | null>) => {
      state.account = payload
    },
    SET_TYPE_LOGIN: (state, {payload}: PayloadAction<TYPE_LOGIN_ENUM>) => {
      state.typeLogin = payload
    },
    SET_JWT_TOKEN: (state, {payload}: PayloadAction<string>) => {
      state.jwt = payload
      httpClient.defaults.headers.Authorization = `Bearer ${payload}`
      fileHttpClient.defaults.headers.Authorization = `Bearer ${payload}`
    },
    SET_REFRESH_TOKEN: (state, {payload}: PayloadAction<string>) => {
      state.refreshToken = payload
    },
    SET_GUEST_MODE: (state, {payload}: PayloadAction<boolean>) => {
      state.guestMode = payload
    },
    SET_DONT_SHOW_AGAIN_BALANCE: (state) => {
      state.dontShowAgain = true
    },
    CLEAR_LOCAL_STORAGE: (state) => {
      state.jwt = ''
      state.refreshToken = ''
      httpClient.defaults.headers.Authorization = null
      fileHttpClient.defaults.headers.Authorization = null
    },
    SET_DATA_MAP: (
      state,
      {payload}: PayloadAction<{x: number; y: number; zoom: number}>
    ) => {
      state.dataMap = payload
    },
    SET_LANGUAGE_STORAGE: (state, {payload}: PayloadAction<string>) => {
      state.language = payload
    },
    SET_EMAIL_FOR_REGISTRATION: (
      state,
      {payload}: PayloadAction<string | null>
    ) => {
      state.emailForRegistration = payload
    },
    SET_FULL_ACCOUNT: (
      state,
      {
        payload,
      }: PayloadAction<{jwt: string; refreshToken: string; account: string}>
    ) => {
      state.jwt = payload.jwt
      state.refreshToken = payload.refreshToken
      state.account = payload.account
      httpClient.defaults.headers.Authorization = `Bearer ${payload.jwt}`
      fileHttpClient.defaults.headers.Authorization = `Bearer ${payload.jwt}`
    },
    SET_ERROR_MODAL_BY_CATCH(state, action) {
      state.modalErrorCode = action.payload
    },
  },
})

export const {
  CLEAR_LOCAL_STORAGE,
  SET_ACCOUNT,
  SET_TYPE_LOGIN,
  SET_GUEST_MODE,
  SET_JWT_TOKEN,
  SET_REFRESH_TOKEN,
  SET_DATA_MAP,
  SET_LANGUAGE_STORAGE,
  SET_EMAIL_FOR_REGISTRATION,
  SET_DONT_SHOW_AGAIN_BALANCE,
  SET_FULL_ACCOUNT,
  SET_ERROR_MODAL_BY_CATCH,
} = slice.actions

export default slice.reducer
